import { render, staticRenderFns } from "./ForgetPwd.vue?vue&type=template&id=192724e6&scoped=true"
import script from "./ForgetPwd.vue?vue&type=script&lang=js"
export * from "./ForgetPwd.vue?vue&type=script&lang=js"
import style0 from "./ForgetPwd.vue?vue&type=style&index=0&id=192724e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192724e6",
  null
  
)

export default component.exports